import { defineStore } from "pinia"
import { NotificationTypes } from "@/types"

export const useNotificationStore = defineStore("notification", {
	state: (): NotificationTypes.NotificationInterface => {
		return {
			notifications: [],
			unreadNotifications: 0
		}
	},
	actions: {
		setNotifications(notifications: NotificationTypes.Notification[]) {
			this.notifications = notifications
		},
		setUnread(unreadNotifications: NotificationTypes.NotificationInterface["unreadNotifications"]) {
			this.unreadNotifications = unreadNotifications
		}
	},
	persist: {
		key: "notifications",
		storage: window.localStorage
	}
})
